import script from "./homeSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./homeSwiper.vue?vue&type=script&setup=true&lang=js"

import "./homeSwiper.vue?vue&type=style&index=0&id=b55ec1c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b55ec1c2"]])

export default __exports__